import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import {AuthService} from '../../../service/authservice/auth.service';



export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);

  if (authService.isAuthenticated()) {
    return true;
  }

  authService.setRedirectUrl(state.url);
  authService.login(); // 🔥 redirect to SSO

  return false;
};
